<template>
  <div id="app" v-cloak>
    <MyHeader v-if="!$route.meta.hideHeader" :lineType="data_lineType" :data_tel="data_tel" />
    <router-view :key="$isZh"></router-view>
    <div class="scroll-top" @click="scrollTop" v-if="!$route.meta.hideFooter">
      <span class="iconfont icon-zuojiantou"></span>
    </div>

    <a class="qr-box" href="https://wa.me/+8615915460684" target="_blank">
      <img src="../src/assets/images/kefupic.png" class="img-auto" alt="China Travel Customer Service WhatsApp">
      <!-- <span>{{ $isZh ?'客服' : 'Customer Service'}}</span> -->
    </a>
    <MyFooter v-if="!$route.meta.hideFooter" :data_system="data_system" :data_tel="data_tel" />
  </div>
</template>

<script>
// import chineseConverter from 'chinese-converter';
import MyHeader from './components/MyHeader.vue'
import MyFooter from './components/MyFooter.vue'
import { getHomeInfo } from '@/api/api.js'
export default {
  name: 'App',
  data() {
    return {
      data_lineType: [],
      data_tel: {},
      data_system: {}
    }
  },
  created() {

    !localStorage.getItem('language') && localStorage.setItem('language', 'en-US')
    this.getHomeInfo()
  },
  mounted() {
    this.injectJsonLd()
  },
  methods: {
    scrollTop() {
      window.scrollTo(0, 0)
    },
    getHomeInfo() {
      let _this = this
      getHomeInfo().then(res => {
        _this.data_lineType = res.data.data_lineType
        _this.data_tel = res.data.data_tel
        _this.data_system = res.data.data_system
        localStorage.setItem('system', JSON.stringify(res.data.data_system))
        localStorage.setItem('data_tel', JSON.stringify(res.data.data_tel))

        let index = res.data.data_system.findIndex(item => item.type == 6)
        let index2 = res.data.data_system.findIndex(item => item.type == 1)

        let pay_type_content = res.data.data_system[index][this.$isZh ? 'post_content' : 'post_content_en']

        localStorage.setItem('pay_type_content', JSON.stringify(pay_type_content))
      })
    },
    injectJsonLd() {
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "TravelAgency",
        "name": "Tenghai Tour",
        "description": "Professional China DMC and China Tour Operator offering China Custom Travel, China Inbound Tour, China Group Tour Ground Handling, China MICE, China Family Travel, Muslim-Friendly China Tour, and tours to Beijing, Shanghai, Zhangjiajie, Guangzhou, Shenzhen.",
        "url": "https://www.cntenghaitour.com",
        "telephone": "+8615915460684",
        "email": "sales@cntenghaitour.com",
        "address": { "@type": "PostalAddress", "addressCountry": "CN" },
        "areaServed": [
          { "@type": "City", "name": "Beijing" },
          { "@type": "City", "name": "Shanghai" },
          { "@type": "City", "name": "Zhangjiajie" },
          { "@type": "City", "name": "Guangzhou" },
          { "@type": "City", "name": "Shenzhen" },
          { "@type": "City", "name": "Yunnan" },
          { "@type": "Country", "name": "China" }
        ],
        "knowsAbout": [
          "China Custom Travel",
          "China Inbound Tour",
          "China DMC for Travel Agencies",
          "China Group Tour Ground Handling",
          "China Family Travel Guide",
          "China Visa-Free Travel Guide",
          "China High-Speed Rail Guide",
          "China MICE and Business Visit",
          "Muslim-Friendly China Tour",
          "China Tour Packages for Seniors",
          "Payment in China for Foreigners",
          "Ni Hao China",
          "China Pandas",
          "Future Shenzhen",
          "Becoming Chinese"
        ]
      })
      document.head.appendChild(script)
    },

  },
  components: {
    MyHeader,
    MyFooter
  },

}
</script>

<style lang="scss" scoped>
#app {
  [v-cloak] {
    display: none;
  }

  .scroll-top {
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    text-align: center;
    background-color: rgba(0, 0, 0, .5);
    position: fixed;
    right: 6px;
    bottom: 100px;
    color: #fff;
    border-radius: 50%;
    transform: rotate(90deg);
    z-index: 999;
  }

  .qr-box {
    position: fixed;
    left: 6px;
    bottom: 50%;
    z-index: 999;
    font-size:30px;
    width: 100px;
    height: 100px;
    text-align: center;
    span{
      margin-top: 4px;
    }
    img{
      display: block;
      width: 100%;
      height: 100%;
    }

  }
}
</style>
